// extracted by mini-css-extract-plugin
module.exports = {"h1":"Htag_h1__A24Pe","h2":"Htag_h2__whxNF","h3":"Htag_h3__zQbZO"};